export const SUPPORTED_COUNTRIES = [ 'BE', 'FR', 'DE', 'NL', 'LU', 'GB', 'IT', 'ES', 'CH', 'IE' ];

export const SUPPORTED_LANGUAGES = {
    FRENCH: "fr",
    ENGLISH: "en",
    DUTCH: "nl",
    GERMAN: "de",
}

export const SUPPORTED_LANGUAGES_NAMES = {
    [SUPPORTED_LANGUAGES.FRENCH]: "misc:languages.fr",
    [SUPPORTED_LANGUAGES.ENGLISH]: "misc:languages.en",
    [SUPPORTED_LANGUAGES.DUTCH]: "misc:languages.nl",
    [SUPPORTED_LANGUAGES.GERMAN]: "misc:languages.de",
};
const SUPPORTED_LANGUAGES_NATIVE_NAMES = {
  [SUPPORTED_LANGUAGES.FRENCH]: "misc:languages_native.fr",
  [SUPPORTED_LANGUAGES.ENGLISH]: "misc:languages_native.en",
  [SUPPORTED_LANGUAGES.DUTCH]: "misc:languages_native.nl",
  [SUPPORTED_LANGUAGES.GERMAN]: "misc:languages_native.de",
};

export const SUPPORTED_LANGUAGES_OPTIONS = Object.entries(SUPPORTED_LANGUAGES_NAMES)
    .map(([value, text]) => ({ text, value, key: value, }));

export const SUPPORTED_LANGUAGES_NATIVE_OPTIONS = Object.entries(SUPPORTED_LANGUAGES_NATIVE_NAMES)
    .map(([value, text]) => ({ text, value, key: value, }));

export const SUPPORTED_LANGUAGES_LIST = Object.values(SUPPORTED_LANGUAGES);

export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.FRENCH;


// WEBPACK FOOTER //
// ./src/constants/locales.js